import API from './clients'

export async function getLastAccessedDevelopments() {
  return API({
    method: 'get',
    url: '/v3/users/last-accessed-building/web',
  })
}
